export const E164_PHONE_NUMBER_REGEX = /^\+1\d{10}$/;